import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Autocomplete from '@mui/material/Autocomplete';
import { Checkbox } from '@mui/material';

// Styled components
export const Container = styled(Grid)(({ theme }) => ({
  width: '100%',
  padding: '24px',
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  borderRadius: '8px',
}));

export const Row = styled(Grid)({
  marginBottom: '8px',
});

export const RowItem = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
});

export const Header = styled('h1')(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '19px',
  color: theme.palette.text.primary,
}));

export const InputLabel = styled('div')(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '19px',
  color: theme.palette.text.primary,
  margin: '18px 0px 8px 0px',
}));

export const PlaceholderBox = styled('div')(({ theme }) => ({
  width: '425px',
  height: '100%',
  backgroundColor: theme.palette.background.subtle,
  border: '1px solid rgba(0, 0, 0, 0.36)',
  borderRadius: '4px',
  padding: '10px 16px',
  paddingLeft: '30px',
  overflow: 'hidden',
  fontSize: '14px',
  lineHeight: '16px',
}));

export const Dropdown = styled(Autocomplete)(({ theme }) => ({
  maxWidth: '650px',
  backgroundColor: `${theme.palette.background.paper} !important`,
}));

export const StyledCheckBox = styled(Checkbox)({
  padding: '0px',
  marginRight: '32px',
});

export const InfoLabel = styled('span')({
  margin: '8px',
  fontSize: '12px',
});

export const BoldText = styled('span')({
  fontWeight: 'bold',
});

export const StyledOpenInNewIcon = styled(OpenInNewIcon)({
  width: '15px',
  height: '15px',
  marginRight: '4px',
});

export const OpenWorkflowText = styled('span')(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '19px',
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  marginTop: '16px',
}));

export const Text = styled('span')({
  fontSize: '14px',
  lineHeight: '19px',
});

export const BlueText = styled('span')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.primary,
  margin: '0px 3px',
  '&:hover': {
    color: 'rgba(33, 150, 243, 0.75)',
  },
  display: 'flex',
  alignItems: 'center',
}));
